import React from 'react';
import { useNavigate } from 'react-router-dom';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import { AppRoutes } from 'types';
import Home from './components/Home';
import LetterBooksIcon from './components/LetterBooksIcon';
import AssignmentsIcon from './components/AssignmentsIcon';
import GreatAlphabetParadeIcon from './components/GreatAlphabetParadeIcon';
import { GREAT_ALPHABET_PARADE_BOOK_CODE } from '@monorepo/shared/src/types';

const tHome = (key: string) => translate('home', key);
const { ASSIGNMENTS, READ_BOOK, LETTER_BOOKS } = AppRoutes;

const HomePage: React.FC = () => {
  const navigate = useNavigate();

  const handleRouteNavButtonClick = (route: string) => navigate(route);

  const homeTiles = [
    {
      title: tHome('letterBooks'),
      Component: LetterBooksIcon,
      onClick: () => handleRouteNavButtonClick(`/${LETTER_BOOKS}`),
    },
    {
      title: tHome('assignments'),
      Component: AssignmentsIcon,
      onClick: () => handleRouteNavButtonClick(`/${ASSIGNMENTS}`),
    },
    {
      title: tHome('greatAlphabetParade'),
      Component: GreatAlphabetParadeIcon,
      onClick: () => handleRouteNavButtonClick(`/${READ_BOOK}/${GREAT_ALPHABET_PARADE_BOOK_CODE}`),
    },
  ];

  return <Home tiles={homeTiles} />;
};

export default HomePage;
